






































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModuleChild } from "@/interfaces/general";
import { GlobalMixin } from "@/mixins/global";

@Component({
  components: {},
  computed: {},
  methods: {}
})
export default class OtherModulesChild extends Mixins(GlobalMixin) {
  @Prop({ type: Object, required: true }) data!: ModuleChild;
  color: string = "";
  animation: string = "";

  setAnimationIn(): void {
    this.color = "benefitCard";
    this.animation = "animate__animated animate__faster animate__slideInDown";
  }
  setAnimationOut(): void {
    this.color = "";
    this.animation = "animate__animated animate__faster animate__slideInUp";
  }
}
